export default __webpack_public_path__ + "static/6p_2-87a2a69a84c35a1f23e081f404ba8a92.png";